import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../providers/AuthContextProvider";
import { LoggedRecruiter } from "../../models/LoggedRecruiter";
import { saveApplicationNoteByEmail} from "../../services/RecruiterService";
import useErrorPage from "../../hooks/useErrorPage";
import { Button } from "../Shared/Buttons/Button";
import { ResponseModel } from "../../models/ResponseModel";
import { ReactComponent as Calender } from '../../assets/svg/calendar.svg';

interface Props {
    jobApplicationId: number;
    preApplicationId: number;
    accessKey: string;
    notes: string;
    isCVLess: boolean;
    styles: any;
    onNoteAdded?: () => void;
}

interface Note {
    author: string;
    note: string;
}

export const NotesTab: React.FC<Props> = (props) => {
    const authContext = useContext(AuthContext);
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();
    const styles = props.styles;  
    const [toErrorPage] = useErrorPage();
    const [previousNotes, setPreviousNotes] = useState<string>("");
    const [jobAppNotes, setJobAppNotes] = useState<Note[]>();
    const [notes, setNotes] = useState<string>('');

    useEffect(() => {
        setPreviousNotes(props.notes ?? "");
        var data = parseNotes(props.notes);
        setJobAppNotes(data);
    }, [props.notes]);

    const parseNotes = (notesHtml: string) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(notesHtml, 'text/html');
        const liElements = doc.querySelectorAll('li');
        const results = Array.from(liElements).map(li => {
            const authorSpan = li.querySelector('span.note-author');
            const authorText = authorSpan?.textContent?.trim() || '';
            const noteText = li.textContent?.replace(authorSpan?.textContent || '', '').replace(/^[:\-\s]+/, '').trim() || '';
            return {
                author: authorText,
                note: noteText
            };
        });
        return results;
    };

    const handleAddNote = () => {
        const trimmedNote = notes.trim();
        if (trimmedNote === "") {
            return;
        }
        const now = new Date();
        const dateString = now.toDateString();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const timeString = `${hours}:${minutes}`;
        const authorText = recruiter?.forename ? `${recruiter.forename} on ` : '';
        const noteText = `<li><i><span class='note-author'> ${authorText} ${dateString} at ${timeString}</span></i> :- ${notes}</li>`;
        const noteHtml = (previousNotes ?? "") + noteText;
        saveApplicationNote(noteHtml);
    };

    const formatNoteText = (text: string) => {
        return text.replace(/\n/g, '<br />');
    };

    async function saveApplicationNote(notes: string) {
        await saveApplicationNoteByEmail(props.jobApplicationId, props.preApplicationId, notes, props.isCVLess, props.accessKey)
        .then((response: ResponseModel) => {
            if (response.status){
                setNotes("");
                if (props.onNoteAdded) {
                    props.onNoteAdded();
                }
            }
        })
        .catch((error) => {            
            toErrorPage(error);
        });
    }

    return (
        <div style={styles.mainWrapper}>
            <div style={styles.rowWrapper}>
                <div style={styles.title}>Notes</div>
            </div>
            <div style={styles.noteSection}>
                <div style={styles.noteWrapper}>
                    <div style={styles.noteWrapper.text}>{"New Note"}</div>
                    <textarea
                        name={"notes"}
                        value={notes} 
                        onChange={(e) => setNotes(e.target.value)} 
                        style={styles.noteWrapper.input}
                        className="scrollArea"
                    />
                    <div style={styles.noteWrapper.buttons}>
                        <Button style={styles.noteWrapper.addNoteButton} onClick={handleAddNote}>{"ADD NOTE"}</Button>
                        <Button style={styles.noteWrapper.discardButton} onClick={() => setNotes("")}>{"DISCARD"}</Button>
                    </div>
                </div>
                {jobAppNotes?.map((jobAppNote) => (
                    <div style={styles.previousNote}>
                        <div style={styles.previousNote.recordInfo}>
                            <Calender style={styles.previousNote.calendarIcon}/>
                            <div style={styles.previousNote.details}>
                                <div style={styles.previousNote.addedDate}>{jobAppNote.author}</div>
                            </div>
                        </div>  
                        <div 
                            style={styles.previousNote.note}
                            dangerouslySetInnerHTML={{__html: formatNoteText(jobAppNote.note)}}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}